import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Alert, Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useAuth } from '../components/AuthContext.tsx';
import { useNavigate } from 'react-router-dom';

function Register() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hasCar, setHasCar] = useState(false);
  const [carMotorization, setCarMotorization] = useState('');
  const [hasMotorcycle, setHasMotorcycle] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);
    try {
      await register({ 
        first_name: firstName, 
        last_name: lastName, 
        email, 
        password, 
        has_car: hasCar, 
        car_motorization: hasCar ? carMotorization : '', 
        has_motorcycle: hasMotorcycle 
      });
      setSuccess('Inscription réussie ! Vous pouvez maintenant vous connecter.');
      // Navigate to login page after successful registration
      setTimeout(() => navigate('/login'), 2000); // Redirect after 2 seconds
    } catch (err: any) {
      setError(err.message || 'Une erreur inattendue est survenue');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
      <Typography variant="h5" component="h1" gutterBottom>
        Inscription
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <TextField 
        margin="normal"
        required
        fullWidth
        id="firstName"
        label="Prénom"
        name="firstName"
        autoComplete="given-name"
        autoFocus
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        id="lastName"
        label="Nom"
        name="lastName"
        autoComplete="family-name"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />
      <TextField
        margin="normal"
        required
        id="email"
        label="Adresse e-mail"
        name="email"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <FormGroup sx={{ mt: 2 }}>
        <FormControlLabel 
          control={<Checkbox checked={hasCar} onChange={(e) => setHasCar(e.target.checked)} />} 
          label="J'ai une voiture" 
        />
        {hasCar && (
          <FormControl fullWidth margin="normal" sx={{ pl: 4 }}>
            <InputLabel id="car-motorization-label">Motorisation</InputLabel>
            <Select
              labelId="car-motorization-label"
              value={carMotorization}
              label="Motorisation"
              onChange={(e) => setCarMotorization(e.target.value)}
            >
              <MenuItem value=""><em>Non spécifié</em></MenuItem>
              <MenuItem value="Thermique">Thermique</MenuItem>
              <MenuItem value="Hybride">Hybride</MenuItem>
              <MenuItem value="Electrique">Électrique</MenuItem>
            </Select>
          </FormControl>
        )}
        <FormControlLabel 
          control={<Checkbox checked={hasMotorcycle} onChange={(e) => setHasMotorcycle(e.target.checked)} />} 
          label="J'ai une moto" 
        />
      </FormGroup>
      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        label="Mot de passe"
        type="password"
        id="password"
        autoComplete="new-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        S'inscrire
      </Button>
    </Box>
  );
}

export default Register;